import { render, staticRenderFns } from "./product-photo.vue?vue&type=template&id=186ec0c6"
import script from "./product-photo.vue?vue&type=script&lang=js"
export * from "./product-photo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports